var _sodipodiNamedview, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolleyball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 31.75 31.750002",
    id: "svg1696",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "volleyball.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1698",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    "inkscapeDocument-units": "px",
    showgrid: "false",
    inkscapeZoom: 4.3994184,
    inkscapeCx: 23.75314,
    inkscapeCy: 81.94265,
    "inkscapWindow-width": 2560,
    "inkscapeWindow-height": 1377,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1",
    units: "px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1693"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Ebene 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    style: {
      display: "inline"
    },
    transform: "translate(-0.03787441,-0.00135587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 19.909361,3.0808678 c 0,1.268966 -1.038652,2.2978783 -2.320515,2.2978783 -1.281337,0 -2.320252,-1.0289123 -2.320252,-2.2978783 0,-1.2689661 1.038915,-2.29761512 2.320252,-2.29761512 1.281863,0 2.320515,1.02864902 2.320515,2.29761512",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0263216
    },
    id: "path1102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.342323,14.302548 c -0.294217,-0.5461 -0.412045,-1.144764 -0.347839,-1.715205 -0.122061,0.03986 -0.237772,0.104422 -0.336197,0.200378 L 8.9113303,14.496929 7.1798969,11.243965 c -0.2247195,-0.422628 -0.7493,-0.582436 -1.1712223,-0.35807 -0.422275,0.225073 -0.5831417,0.749653 -0.3580695,1.171576 l 2.2743585,4.274608 c 0.1287639,0.240947 0.3630084,0.407458 0.6325306,0.449439 0.044097,0.0067 0.088547,0.01023 0.1326445,0.01023 0.2247194,0 0.4427361,-0.08784 0.6057195,-0.247297 l 2.1318368,-2.085622 c -0.02822,-0.05221 -0.05856,-0.104069 -0.08537,-0.156281",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.142512,5.7102923 C 23.765393,5.4167812 23.221057,5.4845145 22.927193,5.8623396 L 20.44787,9.0493342 17.145165,10.490784 c -0.119945,0.05221 -0.221192,0.128764 -0.301978,0.221192 0.384175,0.444147 0.681919,0.973314 0.877006,1.373011 l 0.01094,0.02399 c 0.0011,0.0021 0.0021,0.0042 0.0032,0.0063 0.03528,-0.0099 0.06985,-0.02187 0.104069,-0.03704 l 3.504495,-1.529292 c 0.132644,-0.0575 0.248355,-0.147814 0.337255,-0.262114 L 24.29456,6.9263174 C 24.588071,6.5484923 24.519985,6.0041562 24.142512,5.7102923",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22.564184,23.854007 -3.115027,-4.6736 c -0.09137,-0.137231 -0.207434,-0.248003 -0.337962,-0.331259 l -3.23603,1.918406 -0.174978,3.769078 -2.176639,3.813528 c -0.316795,0.554214 -0.123825,1.259417 0.430036,1.575506 0.180622,0.103364 0.377472,0.1524 0.5715,0.1524 0.401461,0 0.791281,-0.20955 1.004358,-0.582789 l 2.314928,-4.054828 c 0.09031,-0.15875 0.141817,-0.33655 0.150636,-0.519289 l 0.162631,-3.512961 2.088445,3.133372 -2.073628,3.631495 c -0.316089,0.554214 -0.123473,1.259416 0.430389,1.575505 0.180622,0.103364 0.377119,0.1524 0.5715,0.1524 0.401108,0 0.790927,-0.209197 1.004005,-0.582436 l 2.427817,-4.250972 c 0.216958,-0.379942 0.200731,-0.849489 -0.04198,-1.213556",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.141387,18.754957 3.459692,-2.051403 c -0.463198,-1.305631 -1.091848,-2.617964 -1.659467,-3.877733 -0.366536,-0.751417 -0.819503,-1.353256 -1.236134,-1.616428 -0.395463,0.710494 -1.047397,1.246364 -1.859139,1.43898 -0.211666,0.04974 -0.428272,0.07549 -0.644877,0.07549 -0.409223,0 -0.80645,-0.09384 -1.175456,-0.259291 -0.237067,0.464608 -0.272697,1.135239 0.08361,1.79705 0.778581,1.487664 2.003778,3.015192 3.031773,4.493331",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.188659,8.5575619 C 15.500867,9.8765981 14.810128,11.168823 13.646314,11.444343 12.482148,11.719862 11.285878,10.873901 10.974023,9.554512 10.661814,8.2354758 11.3522,6.9428979 12.516367,6.6673785 13.680181,6.3922118 14.877156,7.2381729 15.188659,8.5575619",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1312"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolleyball);
export default __webpack_public_path__ + "static/media/volleyball.1dea268a144ea3bc1d6ebac49a3f3ea2.svg";
export { ForwardRef as ReactComponent };